module.exports = __webpack_public_path__ + "files/9d5ce5ce9e5ef9061b3d211c26065f33.png";